import {createContext, useEffect, useState} from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/remote-config';
import defaultValues from './remoteConfigDefaultValues';
import {isJSON} from 'utils';

const initialState = {
    remoteConfig: null,
};

const RemoteConfigContext = createContext(initialState);

const RemoteConfigProvider = ({children}) => {
    const remoteConfig = firebase.remoteConfig();
    // only for development
    remoteConfig.settings.minimumFetchIntervalMillis = 900000;

    const [flags, setFlags] = useState(defaultValues);

    useEffect(() => {
        remoteConfig.defaultConfig = defaultValues;

        remoteConfig
            .fetchAndActivate()
            .then(activated => {
                return remoteConfig.getAll();
            })
            .then(remoteFlags => {
                const newFlags = {};
                Object.keys(remoteFlags).forEach(key => {
                    let data = remoteFlags[key].asString();
                    if (isJSON(data)) {
                        // will parse bools too
                        data = JSON.parse(data);
                    }
                    if (typeof data === 'object') {
                        newFlags[key] = {...newFlags[key], ...data};
                    } else if (data === '[object Object]') {
                        // object not yet available on server
                        // use default value
                        newFlags[key] = defaultValues[key];
                    } else {
                        newFlags[key] = data;
                    }
                });
                setFlags(newFlags);
            })
            .catch(error => console.error(error));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <RemoteConfigContext.Provider displayName='RemoteConfig' value={flags}>
            {children}
        </RemoteConfigContext.Provider>
    );
};

export default RemoteConfigProvider;
export {RemoteConfigContext};
